import { render, staticRenderFns } from "./ControlesList.vue?vue&type=template&id=6fa48738"
import script from "./ControlesList.vue?vue&type=script&lang=ts"
export * from "./ControlesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports